import flatMap from 'lodash/flatMap.js';
import has from 'lodash/has.js';
import includes from 'lodash/includes.js';
import some from 'lodash/some.js';
import startsWith from 'lodash/startsWith.js';

export default class BasePolicy {
    constructor() {
        this.checks = [];
    }

    before(user) {
        if (user.is_admin) {
            return true;
        }
    }

    hasUserPermissionTo(permission) {
        this.checks.push(user => some(user.permissions, BasePolicy.predicate(permission)));

        return this;
    }

    hasRolePermissionTo(permission) {
        this.checks.push(user =>
            some(
                flatMap(user.roles, role => role.permissions),
                BasePolicy.predicate(permission)
            )
        );

        return this;
    }

    check(user) {
        const hasPermission = includes(
            this.checks.map(check => check(user)),
            true
        );

        this.checks = [];

        return hasPermission;
    }

    setStore(store) {
        this.$store = store;
    }

    static permissionStartsWith(permission, query) {
        if (typeof permission === 'string') {
            return startsWith(permission, query);
        }

        if (typeof permission === 'object' && has(permission, 'action')) {
            return startsWith(permission.action, 'view');
        }
    }

    static predicate(permission) {
        if (typeof permission === 'string') {
            return { name: permission };
        }

        if (typeof permission === 'object' && has(permission, 'action') && has(permission, 'subject')) {
            return permission;
        }
    }
}
